import {
  type Role,
  MODULES,
  EquipmentRepairProcessModule,
  EquipmentRentalProcessModule,
} from "./roles-utils";
import { Stack } from "@mui/material";

function RoleIconList({ role }: { role: Role }) {
  const icons: any = [];

  for (const moduleKey in MODULES) {
    const module = MODULES[moduleKey] as any;

    module.modules.forEach((subModule: any) =>
      subModule.permissions.forEach((permission: any) => {
        if (
          role.permissions.includes(subModule.accessKey + "::" + permission)
        ) {
          if (!icons.includes(module.icon)) icons.push(module.icon);
        }
      })
    );
  }

  EquipmentRepairProcessModule.permissions.forEach((subModule: any) => {
    if (role.permissions.includes(subModule.accessKey)) {
      if (!icons.includes(EquipmentRepairProcessModule.icon))
        icons.push(EquipmentRepairProcessModule.icon);
    }
  });

  EquipmentRentalProcessModule.permissions.forEach((subModule: any) => {
    if (role.permissions.includes(subModule.accessKey)) {
      if (!icons.includes(EquipmentRentalProcessModule.icon))
        icons.push(EquipmentRentalProcessModule.icon);
    }
  });

  return (
    <Stack gap={1} direction="row">
      {icons.map((icon: any, index: any) => (
        <span key={index}>{icon}</span>
      ))}
    </Stack>
  );
}

export default RoleIconList;
